import slugify from '../utils/slugify';

const friends = [
  // {
  //   title: "John Doe",
  //   description: "John is the CEO and has over 20 years of experience in the software industry.",
  //   imgSrc: "/images/boardOfFriends/male.png",
  //   addedDate: new Date('2024-01-15')
  // },
  // {
  //   title: "Jane Smith",
  //   description: "Jane is the CTO with a passion for technology and innovation.",
  //   imgSrc: "/images/boardOfFriends/female.png",
  //   addedDate: new Date('2024-02-20')
  // },
  // {
  //   title: "Sam Johnson",
  //   description: "Sam is the CFO and oversees the financial operations of the company.",
  //   imgSrc: "/images/boardOfFriends/male.png",
  //   addedDate: new Date('2024-03-25')
  // },
];

const sortedFriends = friends
  .map(friend => ({
    ...friend,
    id: slugify(friend.title),
    linkPath: `/board-of-friends/${slugify(friend.title)}`
  }))
  .sort((a, b) => b.addedDate - a.addedDate);

export default sortedFriends;